// components/PersonaSelectorModal.jsx
import { useEffect } from 'react';
import { createPortal } from 'react-dom';



const personas = [
  {
    "name": "Camila Rodríguez",
    "username": "camila.rodriguez@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/camila.rodriguez_Icon.png",
    "description": "Trend-driven shopper, prefers relaxed-fit styles in Size L, spending in the mid to upper price range."
  },
  {
    "name": "Emily Parker",
    "username": "emily.parker@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/emily.parker_Icon.png",
    "description": "Occasional shopper, prefers wide-leg fits in Size M, shopping within a mid-range budget."
  },
  {
    "name": "Rachel Sanders",
    "username": "rachel.sanders@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/rachel.sanders_Icon.png",
    "description": "Frequent shopper, prioritizing comfort fits in Size L, lower to mid-range pricing."
  },
  {
    "name": "Abigail Coleman",
    "username": "abigail.coleman@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/abigail.coleman_Icon.png",
    "description": "Trend-aware shopper, prefers slim-fit styles in Size S, spending within a mid to upper price range."
  },
  {
    "name": "Lauren Mitchell",
    "username": "lauren.mitchell@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/lauren.mitchell_Icon.png",
    "description": "Frequent shopper, leans toward low waist fits in Size M, typically buying within a mid-range budget."
  },
  {
    "name": "Apsara Chaiyaporn",
    "username": "apsara.chaiyaporn@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/apsara.chaiyaporn_Icon.png",
    "description": "Occasional shopper, prefers regular-fit styles in Size M, focusing on lower to mid-range pricing."
  },
  {
    "name": "Advika Gupta",
    "username": "advika.gupta@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/advika.gupta_Icon.png",
    "description": "Style-conscious shopper, prefers tapered fits in Size M, spending mostly in the mid-range."
  },
  {
    "name": "May Phan",
    "username": "may.phan@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/may.phan_Icon.png",
    "description": "Value-driven shopper, prefers relaxed-fit styles in Size S, prioritizing lower price points."
  },
  {
    "name": "Isabela Torres",
    "username": "isabela.torres@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/isabela.torres_Icon.png",
    "description": "Frequent shopper, prefers straight-fit styles in Size L, spending across mid to upper price ranges."
  },
  {
    "name": "Megan Brooks",
    "username": "megan.brooks@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/megan.brooks_Icon.png",
    "description": "Casual browser, prefers comfort-fit styles in Size L, shopping mainly within a mid-range budget."
  },
  {
    "name": "Ethan Miller",
    "username": "ethan.miller@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/ethan.miller_Icon.png",
    "description": "Trend-driven shopper, prefers slim-fit styles in Size M, spending in the mid to upper price range."
  },
  {
    "name": "Carlos Ramirez",
    "username": "carlos.ramirez@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/carlos.ramirez_Icon.png",
    "description": "Frequent shopper, favors relaxed-fit casualwear in Size L, typically shopping within a mid-range budget."
  },
  {
    "name": "Marcus Johnson",
    "username": "marcus.johnson@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/marcus.johnson_Icon.png",
    "description": "Occasional shopper, prefers regular-fit essentials in Size XL, focusing on lower to mid-range pricing."
  },
  {
    "name": "Kenji Tanaka",
    "username": "kenji.tanaka@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/kenji.tanaka_Icon.png",
    "description": "Value-conscious shopper, leans toward comfort-fit styles in Size L, prioritizing affordability and everyday basics."
  }
]
;

const AVATAR_FALLBACK =
  "data:image/svg+xml," +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="%239ca3af"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>'
  );

export default function PersonaSelectorModal({ onClose, onSelectPersona }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  // Portalled for the same reason as SignInModal — and because it is nested
  // inside it, it needs its own escape hatch to sit above.
  return createPortal(
    <div
      className="ob-modalwrap ob-modalwrap-top"
      role="dialog"
      aria-modal="true"
      aria-label="Choose a demo persona"
    >
      <div className="ob-scrim ob-show" onClick={onClose} aria-hidden="true" />

      <div className="ob-modal relative w-full max-w-4xl max-h-[88vh] flex flex-col">
        {/* Header */}
        <div className="ob-hair-b px-6 py-5 flex items-start gap-3 shrink-0">
          <span className="ob-personaglyph" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-[19px] h-[19px]">
              <path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9Z" />
              <path d="M19 16.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8Z" />
            </svg>
          </span>
          <div className="flex-1 min-w-0">
            <div className="ob-eyebrow">Demo login</div>
            <h2 className="ob-display text-[25px] leading-tight mt-0.5">
              Shop as someone
            </h2>
            <p className="text-[12.5px] ob-ink2 mt-1 leading-relaxed">
              Each persona carries its own size, fit and budget — pick one and
              Orbiee will style for them. Credentials fill in automatically.
            </p>
          </div>
          <button
            onClick={onClose}
            className="ob-iconbtn ob-ink2 shrink-0"
            aria-label="Close"
            type="button"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.9} strokeLinecap="round" className="w-[17px] h-[17px]">
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Persona grid */}
        <div className="flex-1 overflow-y-auto ob-scroll px-6 py-5">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 ob-stagger">
            {personas.map((persona) => (
              <button
                key={persona.username}
                type="button"
                onClick={() => onSelectPersona(persona)}
                className="ob-personacard"
              >
                <img
                  src={`${process.env.PUBLIC_URL || ""}${persona.image_url.trim()}`}
                  alt=""
                  className="ob-personaimg"
                  loading="lazy"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = AVATAR_FALLBACK;
                  }}
                />
                <span className="flex-1 min-w-0 text-left">
                  <span className="ob-personaname">{persona.name}</span>
                  <span className="ob-personadesc">{persona.description}</span>
                  <span className="ob-personamail">{persona.username}</span>
                </span>
                <span className="ob-personaarrow" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="w-[14px] h-[14px]">
                    <path d="m9 18 6-6-6-6" />
                  </svg>
                </span>
              </button>
            ))}
          </div>
        </div>

        <div className="ob-hair-t px-6 py-3 text-center ob-ink3 text-[11px] shrink-0">
          Tip — every persona uses the same password, so you can switch freely.
        </div>
      </div>
    </div>,
    document.body
  );
}